import { render, staticRenderFns } from "./KtButton.vue?vue&type=template&id=6c1b7a4f&scoped=true&"
import script from "./KtButton.vue?vue&type=script&lang=js&"
export * from "./KtButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1b7a4f",
  null
  
)

export default component.exports